import styled from 'styled-components'

export const ConfusedLink = styled.a`
  color: #1f1f1f;
  text-decoration: underline;
  font-size: ${(props) => props.theme.labelFontSize};
`
